/* tslint:disable */
/* eslint-disable */
/**
 * Falo Tournament Management
 * This is a sample server about managing the tournaments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export const MatchResult = {
    Win: 'win',
    Draw: 'draw',
    Loss: 'loss'
};
/**
 * MatchApi - axios parameter creator
 * @export
 */
export const MatchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a single match
         * @summary Get a specific match in a tournament
         * @param {string} matchId ID of the match
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatch: (matchId_1, ...args_1) => __awaiter(this, [matchId_1, ...args_1], void 0, function* (matchId, options = {}) {
            // verify required parameter 'matchId' is not null or undefined
            assertParamExists('getMatch', 'matchId', matchId);
            const localVarPath = `/matches/{matchId}`
                .replace(`{${"matchId"}}`, encodeURIComponent(String(matchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the updated game results
         * @summary Updates the result of a match
         * @param {string} matchId ID of match to update
         * @param {PatchMatchResultRequest} body Fields to update in the match result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMatchResult: (matchId_1, body_1, ...args_1) => __awaiter(this, [matchId_1, body_1, ...args_1], void 0, function* (matchId, body, options = {}) {
            // verify required parameter 'matchId' is not null or undefined
            assertParamExists('patchMatchResult', 'matchId', matchId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patchMatchResult', 'body', body);
            const localVarPath = `/matches/{matchId}`
                .replace(`{${"matchId"}}`, encodeURIComponent(String(matchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Submit the result of the match
         * @param {string} matchId ID of match that needs to be updated
         * @param {string} resultHomeSquad Match result for home squad (win, loss, draw)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMatchResult: (matchId_1, resultHomeSquad_1, ...args_1) => __awaiter(this, [matchId_1, resultHomeSquad_1, ...args_1], void 0, function* (matchId, resultHomeSquad, options = {}) {
            // verify required parameter 'matchId' is not null or undefined
            assertParamExists('submitMatchResult', 'matchId', matchId);
            // verify required parameter 'resultHomeSquad' is not null or undefined
            assertParamExists('submitMatchResult', 'resultHomeSquad', resultHomeSquad);
            const localVarPath = `/matches/{matchId}`
                .replace(`{${"matchId"}}`, encodeURIComponent(String(matchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            if (resultHomeSquad !== undefined) {
                localVarQueryParameter['resultHomeSquad'] = resultHomeSquad;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MatchApi - functional programming interface
 * @export
 */
export const MatchApiFp = function (configuration) {
    const localVarAxiosParamCreator = MatchApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a single match
         * @summary Get a specific match in a tournament
         * @param {string} matchId ID of the match
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatch(matchId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMatch(matchId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MatchApi.getMatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the updated game results
         * @summary Updates the result of a match
         * @param {string} matchId ID of match to update
         * @param {PatchMatchResultRequest} body Fields to update in the match result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMatchResult(matchId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchMatchResult(matchId, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MatchApi.patchMatchResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Submit the result of the match
         * @param {string} matchId ID of match that needs to be updated
         * @param {string} resultHomeSquad Match result for home squad (win, loss, draw)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMatchResult(matchId, resultHomeSquad, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitMatchResult(matchId, resultHomeSquad, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MatchApi.submitMatchResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * MatchApi - factory interface
 * @export
 */
export const MatchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MatchApiFp(configuration);
    return {
        /**
         * Returns a single match
         * @summary Get a specific match in a tournament
         * @param {string} matchId ID of the match
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatch(matchId, options) {
            return localVarFp.getMatch(matchId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the updated game results
         * @summary Updates the result of a match
         * @param {string} matchId ID of match to update
         * @param {PatchMatchResultRequest} body Fields to update in the match result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMatchResult(matchId, body, options) {
            return localVarFp.patchMatchResult(matchId, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Submit the result of the match
         * @param {string} matchId ID of match that needs to be updated
         * @param {string} resultHomeSquad Match result for home squad (win, loss, draw)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMatchResult(matchId, resultHomeSquad, options) {
            return localVarFp.submitMatchResult(matchId, resultHomeSquad, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MatchApi - object-oriented interface
 * @export
 * @class MatchApi
 * @extends {BaseAPI}
 */
export class MatchApi extends BaseAPI {
    /**
     * Returns a single match
     * @summary Get a specific match in a tournament
     * @param {string} matchId ID of the match
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    getMatch(matchId, options) {
        return MatchApiFp(this.configuration).getMatch(matchId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the updated game results
     * @summary Updates the result of a match
     * @param {string} matchId ID of match to update
     * @param {PatchMatchResultRequest} body Fields to update in the match result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    patchMatchResult(matchId, body, options) {
        return MatchApiFp(this.configuration).patchMatchResult(matchId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Submit the result of the match
     * @param {string} matchId ID of match that needs to be updated
     * @param {string} resultHomeSquad Match result for home squad (win, loss, draw)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    submitMatchResult(matchId, resultHomeSquad, options) {
        return MatchApiFp(this.configuration).submitMatchResult(matchId, resultHomeSquad, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrganizerApi - axios parameter creator
 * @export
 */
export const OrganizerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add a new organizer
         * @param {Organizer} organizer Organizer object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizer: (organizer_1, ...args_1) => __awaiter(this, [organizer_1, ...args_1], void 0, function* (organizer, options = {}) {
            // verify required parameter 'organizer' is not null or undefined
            assertParamExists('addOrganizer', 'organizer', organizer);
            const localVarPath = `/organizers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(organizer, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrganizerApi - functional programming interface
 * @export
 */
export const OrganizerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add a new organizer
         * @param {Organizer} organizer Organizer object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizer(organizer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addOrganizer(organizer, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrganizerApi.addOrganizer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * OrganizerApi - factory interface
 * @export
 */
export const OrganizerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizerApiFp(configuration);
    return {
        /**
         *
         * @summary Add a new organizer
         * @param {Organizer} organizer Organizer object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizer(organizer, options) {
            return localVarFp.addOrganizer(organizer, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizerApi - object-oriented interface
 * @export
 * @class OrganizerApi
 * @extends {BaseAPI}
 */
export class OrganizerApi extends BaseAPI {
    /**
     *
     * @summary Add a new organizer
     * @param {Organizer} organizer Organizer object that needs to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizerApi
     */
    addOrganizer(organizer, options) {
        return OrganizerApiFp(this.configuration).addOrganizer(organizer, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TeamApi - axios parameter creator
 * @export
 */
export const TeamApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Deletes a team competing in a tournament
         * @param {string} teamId Team ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: (teamId_1, ...args_1) => __awaiter(this, [teamId_1, ...args_1], void 0, function* (teamId, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeam', 'teamId', teamId);
            const localVarPath = `/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a single team
         * @summary Get a specific team competing in a tournament
         * @param {string} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam: (teamId_1, ...args_1) => __awaiter(this, [teamId_1, ...args_1], void 0, function* (teamId, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeam', 'teamId', teamId);
            const localVarPath = `/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Updates a team in the store with form data
         * @param {string} teamId ID of team that needs to be updated
         * @param {string} [club] Updated club name of the team
         * @param {string} [nickName] Updated nick name of the team
         * @param {number} [estimatedSkill] Updated the initial team strength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: (teamId_1, club_1, nickName_1, estimatedSkill_1, ...args_1) => __awaiter(this, [teamId_1, club_1, nickName_1, estimatedSkill_1, ...args_1], void 0, function* (teamId, club, nickName, estimatedSkill, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeam', 'teamId', teamId);
            const localVarPath = `/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            if (club !== undefined) {
                localVarQueryParameter['club'] = club;
            }
            if (nickName !== undefined) {
                localVarQueryParameter['nickName'] = nickName;
            }
            if (estimatedSkill !== undefined) {
                localVarQueryParameter['estimatedSkill'] = estimatedSkill;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TeamApi - functional programming interface
 * @export
 */
export const TeamApiFp = function (configuration) {
    const localVarAxiosParamCreator = TeamApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Deletes a team competing in a tournament
         * @param {string} teamId Team ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam(teamId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTeam(teamId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TeamApi.deleteTeam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns a single team
         * @summary Get a specific team competing in a tournament
         * @param {string} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam(teamId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTeam(teamId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TeamApi.getTeam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Updates a team in the store with form data
         * @param {string} teamId ID of team that needs to be updated
         * @param {string} [club] Updated club name of the team
         * @param {string} [nickName] Updated nick name of the team
         * @param {number} [estimatedSkill] Updated the initial team strength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(teamId, club, nickName, estimatedSkill, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTeam(teamId, club, nickName, estimatedSkill, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TeamApi.updateTeam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * TeamApi - factory interface
 * @export
 */
export const TeamApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TeamApiFp(configuration);
    return {
        /**
         *
         * @summary Deletes a team competing in a tournament
         * @param {string} teamId Team ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam(teamId, options) {
            return localVarFp.deleteTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single team
         * @summary Get a specific team competing in a tournament
         * @param {string} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam(teamId, options) {
            return localVarFp.getTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates a team in the store with form data
         * @param {string} teamId ID of team that needs to be updated
         * @param {string} [club] Updated club name of the team
         * @param {string} [nickName] Updated nick name of the team
         * @param {number} [estimatedSkill] Updated the initial team strength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(teamId, club, nickName, estimatedSkill, options) {
            return localVarFp.updateTeam(teamId, club, nickName, estimatedSkill, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TeamApi - object-oriented interface
 * @export
 * @class TeamApi
 * @extends {BaseAPI}
 */
export class TeamApi extends BaseAPI {
    /**
     *
     * @summary Deletes a team competing in a tournament
     * @param {string} teamId Team ID to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    deleteTeam(teamId, options) {
        return TeamApiFp(this.configuration).deleteTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a single team
     * @summary Get a specific team competing in a tournament
     * @param {string} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    getTeam(teamId, options) {
        return TeamApiFp(this.configuration).getTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates a team in the store with form data
     * @param {string} teamId ID of team that needs to be updated
     * @param {string} [club] Updated club name of the team
     * @param {string} [nickName] Updated nick name of the team
     * @param {number} [estimatedSkill] Updated the initial team strength
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    updateTeam(teamId, club, nickName, estimatedSkill, options) {
        return TeamApiFp(this.configuration).updateTeam(teamId, club, nickName, estimatedSkill, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TournamentApi - axios parameter creator
 * @export
 */
export const TournamentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add a new team competing in a tournament
         * @param {string} tournamentId ID of the tournament for which the teams need to be retrieved
         * @param {Team} team Team object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamToTournament: (tournamentId_1, team_1, ...args_1) => __awaiter(this, [tournamentId_1, team_1, ...args_1], void 0, function* (tournamentId, team, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('addTeamToTournament', 'tournamentId', tournamentId);
            // verify required parameter 'team' is not null or undefined
            assertParamExists('addTeamToTournament', 'team', team);
            const localVarPath = `/tournaments/{tournamentId}/teams`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(team, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add a new tournament
         * @param {Tournament} tournament Tournament object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournament: (tournament_1, ...args_1) => __awaiter(this, [tournament_1, ...args_1], void 0, function* (tournament, options = {}) {
            // verify required parameter 'tournament' is not null or undefined
            assertParamExists('addTournament', 'tournament', tournament);
            const localVarPath = `/tournaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(tournament, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Calculates the matches for the next round in a tournament
         * @param {string} tournamentId ID of the tournament for which the matches need to be calculated
         * @param {number} nextRound Round for which the matches shall be calculated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateNextRound: (tournamentId_1, nextRound_1, ...args_1) => __awaiter(this, [tournamentId_1, nextRound_1, ...args_1], void 0, function* (tournamentId, nextRound, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('calculateNextRound', 'tournamentId', tournamentId);
            // verify required parameter 'nextRound' is not null or undefined
            assertParamExists('calculateNextRound', 'nextRound', nextRound);
            const localVarPath = `/tournaments/{tournamentId}/round`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            if (nextRound !== undefined) {
                localVarQueryParameter['nextRound'] = nextRound;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Removes all matches for a given tournament round.
         * @summary Deletes all matches for a tournament round
         * @param {string} tournamentId ID of the tournament for which the matches should be deleted
         * @param {number} round Deletes matches for a given round
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMatchesForTournamentRound: (tournamentId_1, round_1, ...args_1) => __awaiter(this, [tournamentId_1, round_1, ...args_1], void 0, function* (tournamentId, round, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('deleteMatchesForTournamentRound', 'tournamentId', tournamentId);
            // verify required parameter 'round' is not null or undefined
            assertParamExists('deleteMatchesForTournamentRound', 'round', round);
            const localVarPath = `/tournaments/{tournamentId}/matches`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["write:tournament"], configuration);
            if (round !== undefined) {
                localVarQueryParameter['round'] = round;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Deletes a tournament
         * @param {string} tournamentId Tournament ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournament: (tournamentId_1, ...args_1) => __awaiter(this, [tournamentId_1, ...args_1], void 0, function* (tournamentId, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('deleteTournament', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/{tournamentId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the tournament configuration entity for the specified tournament ID.
         * @summary Get the respective configuration for a given tournament
         * @param {string} tournamentId ID of the tournament for which the configuration needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationForTournament: (tournamentId_1, ...args_1) => __awaiter(this, [tournamentId_1, ...args_1], void 0, function* (tournamentId, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getConfigurationForTournament', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/{tournamentId}/config`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a list of matches
         * @summary Get the matches for a tournament for each round
         * @param {string} tournamentId ID of the tournament for which the matches need to be retrieved
         * @param {number} round Round for which the matches shall be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchesForRoundAndTournament: (tournamentId_1, round_1, ...args_1) => __awaiter(this, [tournamentId_1, round_1, ...args_1], void 0, function* (tournamentId, round, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getMatchesForRoundAndTournament', 'tournamentId', tournamentId);
            // verify required parameter 'round' is not null or undefined
            assertParamExists('getMatchesForRoundAndTournament', 'round', round);
            const localVarPath = `/tournaments/{tournamentId}/matches`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament"], configuration);
            if (round !== undefined) {
                localVarQueryParameter['round'] = round;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the organizer for a specified tournament ID
         * @summary Get the organizer for a tournament
         * @param {string} tournamentId ID of the tournament for which the organizer needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizerByTournamentId: (tournamentId_1, ...args_1) => __awaiter(this, [tournamentId_1, ...args_1], void 0, function* (tournamentId, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getOrganizerByTournamentId', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/{tournamentId}/organizer`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the teams for a specified tournament ID
         * @summary Get the teams competing in a tournament
         * @param {string} tournamentId ID of the tournament for which the teams need to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsInTournament: (tournamentId_1, ...args_1) => __awaiter(this, [tournamentId_1, ...args_1], void 0, function* (tournamentId, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getTeamsInTournament', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/{tournamentId}/teams`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a single tournament
         * @summary Find tournament by ID
         * @param {string} tournamentId ID of tournament to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentById: (tournamentId_1, ...args_1) => __awaiter(this, [tournamentId_1, ...args_1], void 0, function* (tournamentId, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getTournamentById', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/{tournamentId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a a list of  tournaments
         * @summary Find tournament by Name
         * @param {string} tournamentName Tournament\&#39;s name to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentByName: (tournamentName_1, ...args_1) => __awaiter(this, [tournamentName_1, ...args_1], void 0, function* (tournamentName, options = {}) {
            // verify required parameter 'tournamentName' is not null or undefined
            assertParamExists('getTournamentByName', 'tournamentName', tournamentName);
            const localVarPath = `/tournaments/name/{tournamentName}`
                .replace(`{${"tournamentName"}}`, encodeURIComponent(String(tournamentName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all tournaments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournaments: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/tournaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all tournaments by organizer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentsByOrganizer: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/tournaments/byOrganizer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Performs a simulation of the whole tournament and sends the information via email
         * @param {string} tournamentId ID of the tournament for which the organizer needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateEmergencyTournamentPlanAndSendMail: (tournamentId_1, ...args_1) => __awaiter(this, [tournamentId_1, ...args_1], void 0, function* (tournamentId, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('simulateEmergencyTournamentPlanAndSendMail', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/{tournamentId}/simulation`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Updates a tournament in the store
         * @param {string} tournamentId ID of tournament to update
         * @param {TournamentUpdateRequest} updateRequest Fields to update on the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTournament: (tournamentId_1, updateRequest_1, ...args_1) => __awaiter(this, [tournamentId_1, updateRequest_1, ...args_1], void 0, function* (tournamentId, updateRequest, options = {}) {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('updateTournament', 'tournamentId', tournamentId);
            // verify required parameter 'updateRequest' is not null or undefined
            assertParamExists('updateTournament', 'updateRequest', updateRequest);
            const localVarPath = `/tournaments/{tournamentId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication default-oauth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "default-oauth", ["read:tournament", "write:tournament"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TournamentApi - functional programming interface
 * @export
 */
export const TournamentApiFp = function (configuration) {
    const localVarAxiosParamCreator = TournamentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add a new team competing in a tournament
         * @param {string} tournamentId ID of the tournament for which the teams need to be retrieved
         * @param {Team} team Team object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamToTournament(tournamentId, team, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addTeamToTournament(tournamentId, team, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.addTeamToTournament']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Add a new tournament
         * @param {Tournament} tournament Tournament object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournament(tournament, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addTournament(tournament, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.addTournament']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Calculates the matches for the next round in a tournament
         * @param {string} tournamentId ID of the tournament for which the matches need to be calculated
         * @param {number} nextRound Round for which the matches shall be calculated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateNextRound(tournamentId, nextRound, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.calculateNextRound(tournamentId, nextRound, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.calculateNextRound']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Removes all matches for a given tournament round.
         * @summary Deletes all matches for a tournament round
         * @param {string} tournamentId ID of the tournament for which the matches should be deleted
         * @param {number} round Deletes matches for a given round
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMatchesForTournamentRound(tournamentId, round, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMatchesForTournamentRound(tournamentId, round, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.deleteMatchesForTournamentRound']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Deletes a tournament
         * @param {string} tournamentId Tournament ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournament(tournamentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTournament(tournamentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.deleteTournament']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the tournament configuration entity for the specified tournament ID.
         * @summary Get the respective configuration for a given tournament
         * @param {string} tournamentId ID of the tournament for which the configuration needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationForTournament(tournamentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConfigurationForTournament(tournamentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.getConfigurationForTournament']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns a list of matches
         * @summary Get the matches for a tournament for each round
         * @param {string} tournamentId ID of the tournament for which the matches need to be retrieved
         * @param {number} round Round for which the matches shall be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchesForRoundAndTournament(tournamentId, round, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMatchesForRoundAndTournament(tournamentId, round, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.getMatchesForRoundAndTournament']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the organizer for a specified tournament ID
         * @summary Get the organizer for a tournament
         * @param {string} tournamentId ID of the tournament for which the organizer needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizerByTournamentId(tournamentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizerByTournamentId(tournamentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.getOrganizerByTournamentId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the teams for a specified tournament ID
         * @summary Get the teams competing in a tournament
         * @param {string} tournamentId ID of the tournament for which the teams need to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsInTournament(tournamentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTeamsInTournament(tournamentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.getTeamsInTournament']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns a single tournament
         * @summary Find tournament by ID
         * @param {string} tournamentId ID of tournament to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentById(tournamentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTournamentById(tournamentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.getTournamentById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns a a list of  tournaments
         * @summary Find tournament by Name
         * @param {string} tournamentName Tournament\&#39;s name to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentByName(tournamentName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTournamentByName(tournamentName, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.getTournamentByName']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all tournaments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournaments(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTournaments(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.getTournaments']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all tournaments by organizer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentsByOrganizer(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTournamentsByOrganizer(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.getTournamentsByOrganizer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Performs a simulation of the whole tournament and sends the information via email
         * @param {string} tournamentId ID of the tournament for which the organizer needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateEmergencyTournamentPlanAndSendMail(tournamentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.simulateEmergencyTournamentPlanAndSendMail(tournamentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.simulateEmergencyTournamentPlanAndSendMail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Updates a tournament in the store
         * @param {string} tournamentId ID of tournament to update
         * @param {TournamentUpdateRequest} updateRequest Fields to update on the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTournament(tournamentId, updateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTournament(tournamentId, updateRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TournamentApi.updateTournament']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * TournamentApi - factory interface
 * @export
 */
export const TournamentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TournamentApiFp(configuration);
    return {
        /**
         *
         * @summary Add a new team competing in a tournament
         * @param {string} tournamentId ID of the tournament for which the teams need to be retrieved
         * @param {Team} team Team object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamToTournament(tournamentId, team, options) {
            return localVarFp.addTeamToTournament(tournamentId, team, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add a new tournament
         * @param {Tournament} tournament Tournament object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournament(tournament, options) {
            return localVarFp.addTournament(tournament, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Calculates the matches for the next round in a tournament
         * @param {string} tournamentId ID of the tournament for which the matches need to be calculated
         * @param {number} nextRound Round for which the matches shall be calculated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateNextRound(tournamentId, nextRound, options) {
            return localVarFp.calculateNextRound(tournamentId, nextRound, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes all matches for a given tournament round.
         * @summary Deletes all matches for a tournament round
         * @param {string} tournamentId ID of the tournament for which the matches should be deleted
         * @param {number} round Deletes matches for a given round
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMatchesForTournamentRound(tournamentId, round, options) {
            return localVarFp.deleteMatchesForTournamentRound(tournamentId, round, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes a tournament
         * @param {string} tournamentId Tournament ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournament(tournamentId, options) {
            return localVarFp.deleteTournament(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the tournament configuration entity for the specified tournament ID.
         * @summary Get the respective configuration for a given tournament
         * @param {string} tournamentId ID of the tournament for which the configuration needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationForTournament(tournamentId, options) {
            return localVarFp.getConfigurationForTournament(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of matches
         * @summary Get the matches for a tournament for each round
         * @param {string} tournamentId ID of the tournament for which the matches need to be retrieved
         * @param {number} round Round for which the matches shall be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchesForRoundAndTournament(tournamentId, round, options) {
            return localVarFp.getMatchesForRoundAndTournament(tournamentId, round, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the organizer for a specified tournament ID
         * @summary Get the organizer for a tournament
         * @param {string} tournamentId ID of the tournament for which the organizer needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizerByTournamentId(tournamentId, options) {
            return localVarFp.getOrganizerByTournamentId(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the teams for a specified tournament ID
         * @summary Get the teams competing in a tournament
         * @param {string} tournamentId ID of the tournament for which the teams need to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsInTournament(tournamentId, options) {
            return localVarFp.getTeamsInTournament(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single tournament
         * @summary Find tournament by ID
         * @param {string} tournamentId ID of tournament to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentById(tournamentId, options) {
            return localVarFp.getTournamentById(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a a list of  tournaments
         * @summary Find tournament by Name
         * @param {string} tournamentName Tournament\&#39;s name to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentByName(tournamentName, options) {
            return localVarFp.getTournamentByName(tournamentName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all tournaments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournaments(options) {
            return localVarFp.getTournaments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all tournaments by organizer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentsByOrganizer(options) {
            return localVarFp.getTournamentsByOrganizer(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Performs a simulation of the whole tournament and sends the information via email
         * @param {string} tournamentId ID of the tournament for which the organizer needs to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateEmergencyTournamentPlanAndSendMail(tournamentId, options) {
            return localVarFp.simulateEmergencyTournamentPlanAndSendMail(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates a tournament in the store
         * @param {string} tournamentId ID of tournament to update
         * @param {TournamentUpdateRequest} updateRequest Fields to update on the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTournament(tournamentId, updateRequest, options) {
            return localVarFp.updateTournament(tournamentId, updateRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TournamentApi - object-oriented interface
 * @export
 * @class TournamentApi
 * @extends {BaseAPI}
 */
export class TournamentApi extends BaseAPI {
    /**
     *
     * @summary Add a new team competing in a tournament
     * @param {string} tournamentId ID of the tournament for which the teams need to be retrieved
     * @param {Team} team Team object that needs to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    addTeamToTournament(tournamentId, team, options) {
        return TournamentApiFp(this.configuration).addTeamToTournament(tournamentId, team, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add a new tournament
     * @param {Tournament} tournament Tournament object that needs to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    addTournament(tournament, options) {
        return TournamentApiFp(this.configuration).addTournament(tournament, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Calculates the matches for the next round in a tournament
     * @param {string} tournamentId ID of the tournament for which the matches need to be calculated
     * @param {number} nextRound Round for which the matches shall be calculated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    calculateNextRound(tournamentId, nextRound, options) {
        return TournamentApiFp(this.configuration).calculateNextRound(tournamentId, nextRound, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removes all matches for a given tournament round.
     * @summary Deletes all matches for a tournament round
     * @param {string} tournamentId ID of the tournament for which the matches should be deleted
     * @param {number} round Deletes matches for a given round
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    deleteMatchesForTournamentRound(tournamentId, round, options) {
        return TournamentApiFp(this.configuration).deleteMatchesForTournamentRound(tournamentId, round, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes a tournament
     * @param {string} tournamentId Tournament ID to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    deleteTournament(tournamentId, options) {
        return TournamentApiFp(this.configuration).deleteTournament(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the tournament configuration entity for the specified tournament ID.
     * @summary Get the respective configuration for a given tournament
     * @param {string} tournamentId ID of the tournament for which the configuration needs to be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    getConfigurationForTournament(tournamentId, options) {
        return TournamentApiFp(this.configuration).getConfigurationForTournament(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of matches
     * @summary Get the matches for a tournament for each round
     * @param {string} tournamentId ID of the tournament for which the matches need to be retrieved
     * @param {number} round Round for which the matches shall be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    getMatchesForRoundAndTournament(tournamentId, round, options) {
        return TournamentApiFp(this.configuration).getMatchesForRoundAndTournament(tournamentId, round, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the organizer for a specified tournament ID
     * @summary Get the organizer for a tournament
     * @param {string} tournamentId ID of the tournament for which the organizer needs to be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    getOrganizerByTournamentId(tournamentId, options) {
        return TournamentApiFp(this.configuration).getOrganizerByTournamentId(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the teams for a specified tournament ID
     * @summary Get the teams competing in a tournament
     * @param {string} tournamentId ID of the tournament for which the teams need to be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    getTeamsInTournament(tournamentId, options) {
        return TournamentApiFp(this.configuration).getTeamsInTournament(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a single tournament
     * @summary Find tournament by ID
     * @param {string} tournamentId ID of tournament to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    getTournamentById(tournamentId, options) {
        return TournamentApiFp(this.configuration).getTournamentById(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a a list of  tournaments
     * @summary Find tournament by Name
     * @param {string} tournamentName Tournament\&#39;s name to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    getTournamentByName(tournamentName, options) {
        return TournamentApiFp(this.configuration).getTournamentByName(tournamentName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all tournaments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    getTournaments(options) {
        return TournamentApiFp(this.configuration).getTournaments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all tournaments by organizer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    getTournamentsByOrganizer(options) {
        return TournamentApiFp(this.configuration).getTournamentsByOrganizer(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Performs a simulation of the whole tournament and sends the information via email
     * @param {string} tournamentId ID of the tournament for which the organizer needs to be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    simulateEmergencyTournamentPlanAndSendMail(tournamentId, options) {
        return TournamentApiFp(this.configuration).simulateEmergencyTournamentPlanAndSendMail(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates a tournament in the store
     * @param {string} tournamentId ID of tournament to update
     * @param {TournamentUpdateRequest} updateRequest Fields to update on the tournament
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentApi
     */
    updateTournament(tournamentId, updateRequest, options) {
        return TournamentApiFp(this.configuration).updateTournament(tournamentId, updateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
